<template>
  <!-- 圖片展示 -->
  <div :id="targetID" class="carousel mk-carousel slide">
    <!-- 主要圖片顯示區 -->
    <div class="carousel-inner">
      <div v-for  = "(url, index) in imageUrls" 
          :key   = "`m${index}`" 
          :class = "{'active': index == 0}"
          class  = "carousel-item" 
      >
        <div class="mk-carousel__image">
          <div class="mk-image-box">
            <img :src="url" :class="imageClass" loading="lazy" v-if="url">
            <img src="https://placehold.co/200" :class="imageClass" loading="lazy" v-else> 
          </div>
        </div>
      </div>
    </div>

    <!-- 顯示前一個圖片的按鍵 -->
    <button type="button" class="carousel-control-prev" :data-bs-target="getTargetIDSelector" data-bs-slide="prev">
      <span class="carousel-control-prev-icon"></span>
    </button>

    <!-- 顯示後一個圖片的按鍵 -->
    <button type="button" class="carousel-control-next" :data-bs-target="getTargetIDSelector" data-bs-slide="next">
      <span class="carousel-control-next-icon"></span>
    </button>

    <!-- 預覽圖片 -->
    <div class="carousel-indicators">
      <div class="carousel-indicators-inner">
        <button  
          type              ="button"
          :data-bs-target   ="getTargetIDSelector" 
          :data-bs-slide-to ="index"
          v-for             = "(url, index) in imageUrls" 
          :key              = "`p${index}`"
          :class            = "{'active': index == 0}"
        >
          <img :src="url" loading="lazy" v-if="url">
          <img src="https://placehold.co/80" loading="lazy" v-else>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {defineProps, computed} from 'vue'

  const props = defineProps({
    targetID: String,
    imageUrls: Array,
    imageClass: String,
  });

  const getTargetIDSelector = computed(()=>{
    return `#${props.targetID}`;
  })
</script>